var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.418 13.4937V32.9243C46.418 41.3747 41.3723 46.418 32.9243 46.418H13.4937C5.04563 46.418 0 41.3747 0 32.9243V13.4937C0 5.04331 5.04563 0 13.4937 0H32.9243C41.3723 0 46.418 5.04331 46.418 13.4937Z",
    fill: "url(#paint0_linear_3184_3044)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0351 13H16.9649C15.8801 13.0012 15.0012 13.8807 15 14.9663V16.4322H16.5719C16.8021 16.4322 16.9887 16.6189 16.9887 16.8493C16.9887 17.0795 16.8021 17.2664 16.5719 17.2664H15V21.5326H16.5719C16.8021 21.5326 16.9887 21.7195 16.9887 21.9497C16.9887 22.1801 16.8021 22.3668 16.5719 22.3668H15V26.6332H16.5719C16.8021 26.6332 16.9887 26.8199 16.9887 27.0503C16.9887 27.2805 16.8021 27.4674 16.5719 27.4674H15V31.7336H16.5719C16.8021 31.7336 16.9887 31.9205 16.9887 32.1507C16.9887 32.3811 16.8021 32.5678 16.5719 32.5678H15V34.0337C15.0012 35.1193 15.8801 35.9988 16.9649 36H31.0351C32.1199 35.9988 32.9988 35.1193 33 34.0337V14.9663C32.9988 13.8807 32.1199 13.0012 31.0351 13ZM23.9971 18.7202C25.4934 18.7202 26.7063 19.934 26.7063 21.4313C26.7063 22.9287 25.4934 24.1425 23.9971 24.1425C22.5008 24.1425 21.2879 22.9287 21.2879 21.4313C21.289 19.9345 22.5013 18.7214 23.9971 18.7202ZM27.8197 30.2798H20.1742C20.0635 30.2805 19.9572 30.2367 19.8788 30.1583C19.8004 30.0801 19.7567 29.9735 19.7574 29.8627C19.7574 28.6531 20.1982 27.5389 20.996 26.7226C21.7896 25.9217 22.87 25.4713 23.9971 25.4713C25.124 25.4713 26.2044 25.9217 26.998 26.7226C27.7958 27.5389 28.2365 28.6531 28.2365 29.8627C28.2372 29.9735 28.1935 30.0801 28.1151 30.1583C28.0367 30.2367 27.9304 30.2805 27.8197 30.2798Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3184_3044",
    x1: 42.5,
    y1: 3.96703e-7,
    x2: 6.5,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136329,
    stopColor: "#09F6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01889A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/Leads.725cc0cc50cdd73e3ba445d169364f5f.svg";
export { ForwardRef as ReactComponent };